/*
  copied from:
  https://github.com/ckeditor/ckeditor5/blob/v45.0.0/packages/ckeditor5-table/src/utils/common.ts
*/

import type { DocumentSelection, Element } from "ckeditor5";

/**
 * Depending on the position of the selection we either return the table under cursor or look for the table higher in the hierarchy.
 */
export function getSelectionAffectedTable(
  selection: DocumentSelection,
): Element {
  const selectedElement = selection.getSelectedElement();

  // Is the command triggered from the `tableToolbar`?
  if (selectedElement && selectedElement.is("element", "table")) {
    return selectedElement;
  }

  return selection.getFirstPosition()!.findAncestor("table")!;
}
